import React, { useState, useEffect } from 'react'
import { Link } from "react-router-dom"
import Grid from '@mui/material/Grid'
import Typography from '@mui/material/Typography'
import CircularProgress from '@mui/material/CircularProgress'
import Table from '@mui/material/Table';
import Chip from '@mui/material/Chip';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { useAuth0 } from '@auth0/auth0-react'
import { getAllData, deleteData } from '../lib/api'
import nav from '../nav'

const columns = [
  { field: 'name', headerName: 'Name', width: 200 },
  { field: 'created', headerName: 'Created', width: 200 },
]

function GridMenu() {
  const { getAccessTokenSilently } = useAuth0()
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState([])
  const [deleteId, setDeleteId] = useState(null)

  const handleDelete = (id) => {
    console.log('delete', id)
    deleteData(id, getAccessTokenSilently).then(() => {
      fetchData()
    }).catch((err) => {
      console.error(err)
    })
    setDeleteId(null)
  }

  const fetchData = async () => {
    getAllData(getAccessTokenSilently).then((response) => {
      console.log(response)
      const data = response.data
      data.forEach((row) => {
        const navItem = nav.find((item) => item.url === row.url)
        if (navItem) {
          row.icon = navItem.icon
          row.color = navItem.color
          row.tool = navItem.label
        }
      })
      setData(data)
      setLoading(false)
    })
  }

  useEffect(() => {
    fetchData()
  }, [])

  return (
    <Grid flex container spacing={2} mt={2} style={{ maxWidth: '100%' }}>
      <Grid item xs={12}>
         <Typography variant="h2" gutterBottom>
          My Data
        </Typography>
      </Grid>
      <Dialog
        open={deleteId !== null}
        onClose={() => setDeleteId(null)}
      >
        <DialogTitle>
          {"Confirm Delete"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this item? This action cannot be undone.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteId(null)} color="secondary">Cancel</Button>
          <Button onClick={() => handleDelete(deleteId)} color="error" >Delete</Button>
        </DialogActions>
      </Dialog>
      <Grid item xs={12}>
        {loading && <CircularProgress />}
        {!loading && data && <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Tool</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Result</TableCell>
                <TableCell>Date Created</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((row) => (
                <TableRow
                  key={row._id}
                  sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                >
                  <TableCell>
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {row.icon ? <row.icon style={{ color: row.color, marginRight: 10 }} /> : ''}
                      <span>{row.tool}</span>
                    </div>
                  </TableCell>
                  <TableCell>
                    <Link to={`${row.url}/${row._id}`} key={row._id}>
                        {(row.data && row.data.name) ? row.data.name : 'Untitled'}
                    </Link>
                  </TableCell>
                  <TableCell>
                    {(row.data && row.data.preview) ? row.data.preview.split(',').map(v => <Chip variant="outlined" label={v} />) : ''}
                  </TableCell>
                  <TableCell>{new Date(row.created).toLocaleString()}</TableCell>
                  <TableCell>
                    <IconButton aria-label="delete" onClick={() => setDeleteId(row._id)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>}
      </Grid>
    </Grid>
  );
}

export default GridMenu
